import { render } from "./DeveloperAppDetail.vue?vue&type=template&id=ab1d89da"
import script from "./DeveloperAppDetail.vue?vue&type=script&lang=js"
export * from "./DeveloperAppDetail.vue?vue&type=script&lang=js"

import "./DeveloperAppDetail.vue?vue&type=style&index=0&id=ab1d89da&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__